import axios from "axios";

axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers.get='*';


axios.interceptors.response.use(null , error=>{

        const expectedErrors = error.response && error.response.staus >= 400 && error.response.status < 500;

        if(!expectedErrors){
                console.log('مشکلی از سمت سرور وجود دارد');
        }

        return Promise.reject(error)
});


export default {
        get : axios.get ,
        post : axios.post,
        delete : axios.delete,
        put : axios.put,
        create : axios.create,
}